import {localStorageGuard} from "@app/test/manual-testing/helpers/webcomponent-pages"

export const getBdCloudPage = (webComponentSource: string, templateUuid: string): string => {
    return `
<!DOCTYPE html>
<html>
    <head>
        ${localStorageGuard}
        <link href="https://fonts.googleapis.com/css?family=Roboto:200,300,400,500,600,700" rel="stylesheet" />
        <script src=${webComponentSource} type="module"></script>
        <style>
            html, body {
                width: 100%;
                height: 100%;
                margin: 0;
                overflow: hidden;
            }
            cm-configurator-main {
                display: block;
                width: 100%;
                height: 100%;
            }
        </style>
    </head>
    <body>
        <cm-configurator-main template-uuid="${templateUuid}" use-external-menu="true"></cm-configurator-main>
        <cm-bdcloud-api></cm-bdcloud-api>
    </body>
</html>
`
}
